import { useT } from '@/shared/i18n'
import { ErrorState } from '@/shared/ui'

export interface FatalReason {
  kind: 'config'
  issues: string[]
  message: string
}

/**
 * Rendered by the bootstrap instead of the router, so no feature route is ever mounted when the
 * application cannot start safely.
 */
export function FatalScreen({ reason }: { reason: FatalReason }) {
  const t = useT()
  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <ErrorState title={t('fatal.configTitle')} description={t('fatal.configDescription')}>
        <div className="w-full max-w-xl rounded-md border bg-muted p-3 text-left font-mono text-xs">
          <p>{reason.message}</p>
          {reason.issues.length > 0 ? (
            <ul className="mt-2 list-disc pl-5">
              {reason.issues.map((issue) => (
                <li key={issue}>{issue}</li>
              ))}
            </ul>
          ) : null}
        </div>
      </ErrorState>
    </main>
  )
}
